/* MUI */
import { Box } from '@mui/material';

/*  Shared  */
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/* Objects */
import { Application } from 'objects/Application';

/*  React  */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'router/withRouter';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';
import ManagedPicker from './Managed';

const AppPicker = (props) => {
    const loadApps = async ({ allApplications, clientId, setApps }) => {
        /* api params */
        const params = {
            applicationId: '*',
            includeApplication: true,
            includeManagementStage: true,
            size: -1
        };
        if (!allApplications) {
            params.classified = true;
        }
        if (clientId) {
            params.platformTenantId = clientId;
        }
        params.includeClients = true;
        params.includeUncataloged = true;
        params.includeUncategorizedWorkLogins = true;
        params.includeRemoved = true;

        try {
            const { CancelToken } = axios;
            const source = CancelToken.source();
            const response = await axios.get('/tenantApp', {
                cancelToken: source.token,
                params
            });
            if (!Response.hasData(response)) {
                debug.w('No Apps Found', response);
            }

            const data = Response.getData(response).map((r) => ({
                ...r.application,
                link: { ...r }
            }));
            const apps = data.sort((a, b) => `${a.name}`.localeCompare(b.name));
            setApps(apps);
        } catch (e) {
            debug.e('Error getting Tenant Apps', e);
        }
    };

    const makePayload = ({
        apps,
        setLoaded,
        setObjectPayload,
        hideManagedBadge
    }) => {
        setLoaded(false);
        const objectPayload = [];

        apps.forEach((app, index) => {
            objectPayload[index] = {
                ...app,
                componentToDisplay: (
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                    >
                        <Application data={app}>
                            <ApplicationNameLinkCell nameNoTruncate />
                        </Application>

                        {!hideManagedBadge && (
                            <ManagedPicker
                                visualOnly
                                iconOnly
                                value={app.link.managementStage}
                            />
                        )}
                    </Box>
                )
            };
        });

        setObjectPayload(objectPayload);
        setLoaded(true);
    };

    const [apps, setApps] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [objectPayload, setObjectPayload] = useState([]);

    const { allApplications, match } = props;
    const { clientId } = match.params;

    useEffect(() => {
        async function fetchData() {
            await loadApps({ allApplications, clientId, setApps });
        }
        fetchData();
    }, [allApplications, clientId]);

    useEffect(() => {
        makePayload({
            apps,
            hideManagedBadge: props.hideManagedBadge,
            setLoaded,
            setObjectPayload,
            visualOnly: props.visualOnly
        });
    }, [apps, props.visualOnly, props.hideManagedBadge]);

    return (
        loaded && (
            <ObjectPicker
                {...props}
                objectPayload={objectPayload}
                objectNameField="name"
                objectNameFieldVisualOnly="componentToDisplay"
                visualOnlyDefault={undefined}
            />
        )
    );
};

export default withRouter(AppPicker);
